
import React from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';

interface AvatarFeedbackProps {
  qualityFeedback: string | null;
  processingError: string | null;
  isStorageLimited: boolean;
}

const AvatarFeedback: React.FC<AvatarFeedbackProps> = ({
  qualityFeedback,
  processingError,
  isStorageLimited
}) => {
  return (
    <>
      {qualityFeedback && (
        <Alert variant="default" className="py-2 mt-2">
          <AlertCircle className="h-4 w-4" />
          <AlertDescription className="text-xs">
            {qualityFeedback}
          </AlertDescription>
        </Alert>
      )}
      
      {processingError && (
        <Alert variant="destructive" className="py-2 mt-2">
          <AlertCircle className="h-4 w-4" />
          <AlertDescription className="text-xs">
            {processingError}
          </AlertDescription>
        </Alert>
      )}
      
      {isStorageLimited && (
        <Alert variant="destructive" className="py-2 mt-2">
          <AlertCircle className="h-4 w-4" />
          <AlertDescription className="text-xs">
            Supabase storage access is limited. Your image will be displayed but not permanently stored.
          </AlertDescription>
        </Alert>
      )}
    </>
  );
};

export default AvatarFeedback;
